"use client";
import React from "react";
import { CommentType } from "../../../constants/mockPosts";
import { useState } from "react";
const Comment3 = ({ comment }: { comment: CommentType }) => {
  const [showReplies, setShowReplies] = useState(false);

  return (
    <div className=" border-themeColor text-secondary-main my-4">
      <div className="flex w-full items-start gap-5">
        <img
          src={comment.photo}
          alt={comment.name}
          className="size-12 rounded-md"
        />
        <div className=" flex-1">
          <div className="first flex items-center w-full  justify-between">
            <div className="items flex items-center gap-6">
              <h5 className="!font-bold h6">{comment.name}</h5>
            </div>
            <p className="text-sm text-label-main">
              {new Date(comment.date).toDateString()}
            </p>
          </div>

          <p className="mt-1">{comment.text}</p>

          {comment.replies.length > 0 && (
            <button
              onClick={() => setShowReplies(!showReplies)}
              className="text-themeColor text-sm mt-2"
            >
              <span className="flex gap-2 items-center">
                {showReplies ? "Hide Replies" : `Show Replies`}
              </span>
            </button>
          )}

          {showReplies && (
            <div className="mt-2 ml-5 border-gray-200 pl-3">
              {comment.replies.map((reply) => (
                <Comment3 key={reply.id} comment={reply} />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Comment3;
